// @generated by protoc-gen-connect-web v0.6.0 with parameter "target=ts,ts_nocheck=false"
// @generated from file api/scribe/svc_registry.proto (package com.diagnocat.scribe, syntax proto3)
/* eslint-disable */

import { ListRegistryAssetsReq, ListRegistryAssetsResp } from "./svc_registry_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service com.diagnocat.scribe.RegistryService
 */
export const RegistryService = {
  typeName: "com.diagnocat.scribe.RegistryService",
  methods: {
    /**
     * Browses encounter schemas, document templates and analytics models an
     * organization can adopt, across all three families in one listing.
     *
     * @generated from rpc com.diagnocat.scribe.RegistryService.List
     */
    list: {
      name: "List",
      I: ListRegistryAssetsReq,
      O: ListRegistryAssetsResp,
      kind: MethodKind.Unary,
    },
  }
} as const;

